<template>
    <dv-border-box-12 class="item-container">
        <!-- 2023年11月10日 预警修改改为了报警 -->
        <div class="item-title">报警消息</div> 
        <div id="scroll-board">
            <dv-scroll-board :config="config" @click="clickEvent" />
        </div>
    </dv-border-box-12>
</template>

<script>
/* eslint-disable */
import EventBus from "../js/event-bus.js";

export default {
    name: "AlarmEvent",
    data() {
        return {
            config: null,
            alarmList: [],
        };
    },
    mounted() {
        this.getAlarmTopNUnhandled();
    },
    methods: {
        clickEvent(row) {
            if (row.rowIndex >= this.alarmList.length) {
                return;
            }
            var item = this.alarmList[row.rowIndex];
            if (item) {
                EventBus.$emit("showAlarmEvent", item);
            }
        },
        getAlarmTopNUnhandled() {
            this.$api
                .getAlarmTopNUnhandled()
                .then((result) => {
                    if (result.ok === true) {
                        this.alarmList = result.data;
                        var temp = result.data.map(function (x) {
                            var time = x.createdTime;
                            if (x.updatedTime) {
                                time = x.updatedTime;
                            }
                            return [x.content, time];
                        });
                        this.config = {
                            //header: ["时间", "内容"],
                            index: true,
                            columnWidth: [50, 220, 150],
                            align: ["center"],
                            rowNum: 10,
                            headerBGC: "#1981f6",
                            headerHeight: 45,
                            oddRowBGC: "rgba(0, 44, 81, 0.8)",
                            evenRowBGC: "rgba(10, 29, 50, 0.8)",
                            data: temp,
                        };
                    } else {
                        console.log("请求失败!");
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>

<style lang="less">
.item-container {
    .border-box-content {
        padding: 20px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
    }

    .item-title {
        height: 20px;
        line-height: 20px;
        font-size: 16px;
        text-indent: 20px;
        margin: 10px 0;
    }

    #scroll-board {
        box-sizing: border-box;
        height: 100%;
        overflow: hidden;
    }

    #scroll-board .dv-scroll-board .rows .row-item {
        cursor: pointer;
        height: 40px !important;
        line-height: 40px !important;
    }
}
</style>
